<div id="newly-eligible-banner" class="card bg-primary" style="padding: 15px">
    <div fxLayout="column" fxLayoutAlign="center center" class="fxGap-medium">
      <h4 class="card-title">Spousal Attestation</h4>
      <p id="banner-text" class="card-text">
        You are required to attest to the spouse or state-registered domestic partner coverage premium surcharge
        for coverage effective January {{nextYear | date:'yyyy'}}.  If you do not, you will be charged the monthly $50
        premium surcharge. Attest by selecting the open enrollment button and then select the "Edit" option for your
        spouse or SRDP. If you are removing them from medical coverage for {{nextYear | date:'yyyy'}}, you do not need to attest.
      </p>
    </div>
  </div>